// src/pages/auth/Login.js
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from '../../utils/axios';
import { FiMail, FiLock, FiEye, FiEyeOff } from 'react-icons/fi';

const Login = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post('/api/auth/login', formData);
      
      if (response.data.success) {
        const user = response.data.data.user;
        
        // ✅ Debug: Console-д харуулах
        console.log('🔐 Login successful:', {
          email: user.email,
          role: user.role_name,
          full_name: user.full_name
        });
        
        toast.success(`Сайн байна уу, ${user.full_name}!`);
        
        // ✅ Role-оор redirect
        if (user.role_name === 'admin' || user.role_name === 'staff') {
          console.log('➡️ Redirecting to: /admin/dashboard');
          navigate('/admin/dashboard', { replace: true });
        } else {
          console.log('➡️ Redirecting to: /customer/products');
          navigate('/customer/products', { replace: true });
        }
      }
    } catch (error) {
      console.error('❌ Login error:', error);
      const message = error.response?.data?.message || 'Алдаа гарлаа';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        {/* Logo */}
        <div className="auth-logo">
          <div className="auth-logo-icon">
            <img src="/logo.png" alt="Logo" />
          </div>
          <h1 className="auth-title">Бөөний Борлуулалт</h1>
          <p className="auth-subtitle">Системд нэвтрэх</p>
        </div>

        {/* Login Card */}
        <div className="auth-card">
          <form onSubmit={handleSubmit}>
            {/* Email */}
            <div className="auth-form-group">
              <label className="auth-label">Имэйл хаяг</label>
              <div className="auth-input-wrapper">
                <div className="auth-input-icon">
                  <FiMail size={18} />
                </div>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="auth-input"
                  placeholder="example@email.com"
                  required
                />
              </div>
            </div>

            {/* Password */}
            <div className="auth-form-group">
              <label className="auth-label">Нууц үг</label>
              <div className="auth-input-wrapper">
                <div className="auth-input-icon">
                  <FiLock size={18} />
                </div>
                <input
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  className="auth-input pr-10"
                  placeholder="••••••••"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600"
                >
                  {showPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
                </button>
              </div>
            </div>

            {/* Remember & Forgot */}
            <div className="flex items-center justify-between mb-6">
              <label className="flex items-center cursor-pointer">
                <input type="checkbox" className="checkbox" />
                <span className="ml-2 text-sm text-gray-600">Намайг сана</span>
              </label>
              <a href="#" className="text-sm auth-link">
                Нууц үг мартсан?
              </a>
            </div>

            {/* Submit */}
            <button
              type="submit"
              disabled={loading}
              className="btn btn-primary w-full"
            >
              {loading ? (
                <>
                  <div className="spinner mr-2"></div>
                  Нэвтэрч байна...
                </>
              ) : (
                'Нэвтрэх'
              )}
            </button>
          </form>

          {/* Divider */}
          <div className="auth-divider">
            <span>эсвэл</span>
          </div>

          {/* Register Link */}
          <div className="text-center">
            <p className="text-sm text-gray-600">
              Бүртгэлгүй юу?{' '}
              <Link to="/register" className="auth-link">
                Бүртгүүлэх
              </Link>
            </p>
          </div>
        </div>

        {/* Demo Credentials */}
        
      </div>
    </div>
  );
};

export default Login;